export default "__VITE_ASSET__a8547f83__"